"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewComponentProvider = void 0;
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const react_bootstrap_1 = require("react-bootstrap");
const function_client_1 = require("@/utils/function-client");
const standard_1 = require("react-hook-schema/standard");
const storage_1 = require("firebase/storage");
const firebase_app_1 = __importDefault(require("common/firebase-app"));
const pages_1 = require("../../../../../pages");
const url_1 = require("utils/url");
const schema_1 = require("../list/schema");
const storage = (0, storage_1.getStorage)(firebase_app_1.default);
const PreviewComponentProvider = ({ projectId, }) => {
    const PreviewComponent = ({ control }) => {
        const { auditLogId, constraint } = (0, react_hook_form_1.useWatch)({ control });
        const { value: searchParamsValue } = (0, url_1.useSearchParamAccessor)();
        const { path, collectionName } = searchParamsValue || {};
        const [data, setData] = (0, react_1.useState)();
        (0, react_1.useEffect)(() => {
            setData(undefined);
        }, [auditLogId]);
        const confirm = (0, standard_1.useConfirm)();
        const navigate = (0, pages_1.useTypedNavigate)();
        const contextText = (0, react_1.useMemo)(() => {
            if (path) {
                return undefined;
            }
            else if (collectionName && projectId) {
                return `この翻訳プロジェクトの「${schema_1.collectionNameMap[collectionName]}」のすべてのデータ`;
            }
            else if (projectId) {
                return `この翻訳プロジェクトのすべてのデータ`;
            }
            else {
                return undefined;
            }
        }, [collectionName, projectId, path]);
        const toast = (0, standard_1.useToast)();
        const pageConstraint = (0, react_1.useMemo)(() => {
            if (projectId) {
                return { projectId };
            }
            else {
                return undefined;
            }
        }, [projectId]);
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { style: { padding: "10px" } },
                react_1.default.createElement(react_bootstrap_1.Button, { "data-tooltip-id": "tooltip", "data-tooltip-content": "この操作のみを差し戻す", variant: "danger", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        const result = yield confirm({
                            message: (react_1.default.createElement("div", null,
                                react_1.default.createElement("span", { style: { fontWeight: "bold", color: "red" } }, "\u3053\u306E\u64CD\u4F5C\u3067\u306F\u3001\u6574\u5408\u6027\u30C1\u30A7\u30C3\u30AF\u306F\u884C\u308F\u308C\u306A\u3044\u305F\u3081\u3001\u30C7\u30FC\u30BF\u306E\u6574\u5408\u6027\u306B\u91CD\u5927\u306A\u554F\u984C\u3092\u5F15\u304D\u8D77\u3053\u3059\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002"),
                                react_1.default.createElement("br", null),
                                "\u3053\u306E\u64CD\u4F5C\u306E\u5BFE\u8C61\u3068\u306A\u3063\u305F\u30C7\u30FC\u30BF\u3060\u3051\u304C\u66F4\u65B0\u524D\u306E\u30C7\u30FC\u30BF\u306B\u30EA\u30BB\u30C3\u30C8\u3055\u308C\u307E\u3059\u3002\u305D\u308C\u4EE5\u964D\u306E\u66F4\u65B0\u3068\u6574\u5408\u6027\u304C\u53D6\u308C\u306A\u304F\u306A\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002\u672C\u5F53\u306B\u3082\u3068\u306B\u623B\u3057\u307E\u3059\u304B\uFF1F")),
                        });
                        if (!result)
                            return;
                        yield (0, function_client_1.reviseAction)({
                            auditLogId,
                            mode: "undo",
                            constraint: pageConstraint,
                        });
                        toast({
                            message: "差し戻しました",
                            duration: 5000,
                        });
                    }) }, "\u30EA\u30D0\u30FC\u30C8"),
                react_1.default.createElement("p", { style: { padding: "5px" } }, "\u3053\u306E\u64CD\u4F5C\u3092\u5DEE\u3057\u623B\u3057\u3001\u64CD\u4F5C\u9069\u7528\u524D\u306E\u72B6\u614B\u306B\u623B\u3057\u307E\u3059\u3002")),
            contextText && (react_1.default.createElement("div", { style: { padding: "10px" } },
                react_1.default.createElement(react_bootstrap_1.Button, { "data-tooltip-id": "tooltip", "data-tooltip-content": `${contextText}について、この操作適用前のCheckpointに戻す`, variant: "danger", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        const result = yield confirm({
                            message: (react_1.default.createElement("div", null,
                                path ? (react_1.default.createElement("span", { style: { fontWeight: "bold", color: "red" } }, "\u3053\u306E\u64CD\u4F5C\u3067\u306F\u3001\u6574\u5408\u6027\u30C1\u30A7\u30C3\u30AF\u306F\u884C\u308F\u308C\u306A\u3044\u305F\u3081\u3001\u30C7\u30FC\u30BF\u306E\u6574\u5408\u6027\u306B\u91CD\u5927\u306A\u554F\u984C\u3092\u5F15\u304D\u8D77\u3053\u3059\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002")) : (react_1.default.createElement("span", { style: { fontWeight: "bold", color: "red" } }, "\u3053\u306E\u64CD\u4F5C\u306F\u591A\u6570\u306E\u30C7\u30FC\u30BF\u306B\u5F71\u97FF\u3059\u308B\u975E\u5E38\u306B\u5371\u967A\u306A\u64CD\u4F5C\u3067\u3059\u3002\u3053\u306E\u64CD\u4F5C\u3067\u306F\u3001\u6574\u5408\u6027\u30C1\u30A7\u30C3\u30AF\u306F\u884C\u308F\u308C\u306A\u3044\u305F\u3081\u3001\u30C7\u30FC\u30BF\u306E\u6574\u5408\u6027\u306B\u91CD\u5927\u306A\u554F\u984C\u3092\u5F15\u304D\u8D77\u3053\u3059\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002")),
                                react_1.default.createElement("br", null),
                                contextText,
                                "\u304C\u3001\u66F4\u65B0\u524D\u306E\u30C7\u30FC\u30BF\u306B\u30EA\u30BB\u30C3\u30C8\u3055\u308C\u307E\u3059\u3002\u672C\u5F53\u306B\u9069\u7528\u3057\u307E\u3059\u304B\uFF1F")),
                        });
                        if (!result)
                            return;
                        yield (0, function_client_1.reviseAction)({
                            auditLogId,
                            mode: "moveBefore",
                            constraint: pageConstraint,
                        });
                        toast({
                            message: "差し戻しました",
                            duration: 5000,
                        });
                    }) }, "\u30ED\u30FC\u30EB\u30D0\u30C3\u30AF"),
                react_1.default.createElement("p", { style: { padding: "5px" } },
                    contextText,
                    "\u306B\u3064\u3044\u3066\u3001\u3053\u306E\u64CD\u4F5C\u9069\u7528\u524D\u306ECheckpoint\u306B\u623B\u3059"))),
            !projectId && constraint.projectId && (react_1.default.createElement("div", { style: { padding: "10px" } },
                react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        navigate("LIST_PROJECT_AUDIT_LOG", {
                            projectId: constraint.projectId,
                        });
                    }) }, "\u3053\u306E\u7FFB\u8A33\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u5C65\u6B74\u3092\u898B\u308B"))),
            react_1.default.createElement("div", { style: { padding: "10px" } },
                data === undefined && (react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        (() => __awaiter(void 0, void 0, void 0, function* () {
                            setData("loading");
                            const dataRef = (0, storage_1.ref)(storage, `auditLog/${auditLogId}`);
                            const url = yield (0, storage_1.getDownloadURL)(dataRef);
                            const result = yield fetch(url);
                            const data = yield result.text();
                            setData(JSON.stringify(JSON.parse(data), null, 2));
                        }))();
                    }) }, "\u30C7\u30FC\u30BF\u3092\u898B\u308B")),
                data !== undefined && (react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 6, value: data, readOnly: true })))));
    };
    return PreviewComponent;
};
exports.PreviewComponentProvider = PreviewComponentProvider;
